import { Link, useParams } from "react-router-dom";
import Icon from "../../../../components/icons";
import PageHero from "../../../../components/PageHero";
import SiteLayout from "../../../../components/SiteLayout";

const launchpadNames: Record<string, string> = {
  com: "Commerce foundation",
  srv: "Service business",
  ops: "Operations portal",
};

const DemoComponent = () => {
  const { page = "" } = useParams();
  const title = launchpadNames[page.toLowerCase()] || "Product launchpad";

  return (
    <SiteLayout>
      <PageHero
        compact
        eyebrow="Launchpad preview"
        title={<>{title}, <span>made adaptable.</span></>}
        description="This preview shows the structure we can shape around your brand, workflows, integrations, and customers."
      >
        <div className="hero-actions">
          <Link className="button" to="/#contact">Request a live walkthrough <Icon name="arrow" /></Link>
          <Link className="button button-secondary" to="/websites">Explore websites</Link>
        </div>
      </PageHero>
      <section className="light-section demo-section">
        <div className="site-container demo-browser">
          <div className="demo-toolbar"><span/><span/><span/><em>Preview canvas</em></div>
          <div className="demo-shell">
            <aside><b/><b/><b/><b/><i/></aside>
            <div className="demo-canvas">
              <div className="demo-heading"><span/><span/></div>
              <div className="demo-cards"><i/><i/><i/></div>
              <div className="demo-table"><span/><span/><span/><span/></div>
            </div>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
};

export default DemoComponent;
